<template>
  <div class="footerBanner" v-show="loading && ishow">
    <div class="footerBox" @click="toLink()">
      <img
        @load="handleImageLoad"
        class="img"
        :src="$utils.getPng(domSrc)"
      />
      <!-- 不限时长会员用了多少次特权 -->
      <div
        :class="{
          downNum: true,
          downOne: digitCount == 1,
          downTwo: digitCount == 2,
          downThree: digitCount >= 3,
        }"
        v-if="loading && type == 2"
      >
        {{ downDayCount }}
      </div>
      <!-- 会员已过期多少天 -->
      <div
        :class="{
          expire: true,
          expireFour: dayCount >= 4,
        }"
        v-if="loading && type == 3"
      >
        {{ day }}
      </div>
      <div class="footerBox_button">
        <div class="footerBox_button_item" :style="{backgroundImage: footerButtonBack}" v-for="item in downPageVipLabel" :key="item.id">
          <img :src="$utils.getPng(item.icon)" class="icon"/>
          <span v-html="item.text"></span>
          <img v-if="item.id == '30'" :src="$utils.getPng('footerBanner_icon_arrowRight')" class="icon_arrow"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBanner',
  props: {
    type: {
      type: String,
      default: '6', //0-未登录、1-未开通过会员、2-不限时长会员、3-会员已过期、4-会员即将过期、5-会员、6-不展示
    },
    downDayCount: {
      type: String,
      default: '0',
    },
    day: {
      type: String,
      default: '0',
    },
    ishow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      footerButtonBack: `url(${this.$utils.getPng('footerBanner_button_back')})`,
    }
  },
  mounted() {

  },
  computed: {
    domSrc() {
      switch (this.type) {
        case '0':
          return 'footerBanner_back_00'
        case '1':
          return 'footerBanner_back_11'
        case '2':
          if (this.digitCount == 1) {
            return 'footerBanner_back_4_11'
          } else if (this.digitCount == 2) {
            return 'footerBanner_back_4_22'
          } else if (this.digitCount >= 3) {
            return 'footerBanner_back_4_33'
          }
        case '3':
          if (this.dayCount == 1) {
            return 'footerBanner_back_3_11'
          } else if (this.dayCount == 2) {
            return 'footerBanner_back_3_22'
          } else if (this.dayCount == 3) {
            return 'footerBanner_back_3_33'
          } else if (this.dayCount >= 4) {
            return 'footerBanner_back_3_44'
          }
        case '4':
          return 'footerBanner_back_44'
        case '5':
          return 'footerBanner_back_55'
        default:
        // return 'icon-down-footerOne'
      }
    },
    digitCount() {
      return this.downDayCount.toString().length
    },
    dayCount() {
      return this.day.toString().length
    },
    downPageVipLabel(){
      switch (this.type) {
        case '0':
          return this.getLabel(['31', '32', '33'])
        case '1':
        case '3':
          return this.getLabel(['27', '28', '29'])
        case '2':
          return this.getLabel(['28', '25', '26', '30'])
        case '4':
        case '5':
          return this.getLabel(['24', '25', '26'])
        default:
      }
    },
    
  },
  methods: {
    handleImageLoad() {
      this.loading = true
      this.$emit('loaded') // 通知父组件图片已加载
    },
    getHeight() {
      return this.$el.clientHeight
    },
    toLink() {
      if (this.type == '0') {
        let path = this.$route.fullPath.toString().slice(1)
        const lang = {
          en: '/en-US',
          hk: '/zh-HK',
          cn: '',
        }
        const routeData = this.$router.resolve({
          path: lang[this.$store.state.language] + '/login',
          query: {
            tab: 2,
            path,
          },
        })
        window.open(routeData.href, '_blank')
      } else {
        window.open('/vip', '_blank')
      }
    },
    getLabel(val){
      return val.map(item => {
        const label_spec = this.$store.state.downPageVipLabel[item].label_spec
        const label = this.$store.state.downPageVipLabel[item].label
        return {
          id: item,
          icon: this.buttonIconSrc(item),
          text: label_spec ? this.highlightedText(label, label_spec) : label
        }
      })
    },
    buttonIconSrc(id){
      switch (id) {
        case '24':
        case '28':
          return 'footerBanner_icon_download'
        case '25':
        case '29':
          return 'footerBanner_icon_cloud'
        case '26':
          return 'footerBanner_icon_member'
        case '27':
          return 'footerBanner_icon_speed'
        case '30':
          return 'footerBanner_icon_more'
        case '31':
          return 'footerBanner_icon_share'
        case '32':
          return 'footerBanner_icon_transfer'
        case '33':
          return 'footerBanner_icon_multifaceted'
        default:
      }
    },
    highlightedText(originalString, replaceString) {
      const reg = new RegExp(replaceString, "g");
      return originalString.replace(reg, `<span style="color:#F67942;">${replaceString}</span>`);
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
